/**
 * <SelectClass 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import SelectClassModal from 'template/Modals/SelectClass';

class SelectClass extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    let props = this.props;

    return (
      <div className='select-class-button'>
        class
        <a className='btn-link' onClick={()=>{
          let schoolId = localStorage.getItem('schoolId');
          const {
            selectMultiple,
          } = props.options;
            
          SelectClassModal({ schoolId, selectMultiple })
            .then((classs)=>{
              props.onChange(classs);
            })
            .catch((err)=>{
              console.error(err); 
            });
          }}>{__('Select', 'class')}</a>
      </div>
    )
  }
}

export default SelectClass;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/SelectClass.js